<template>
  <pwa-layout title="Nouveau véhicule" subtitle="GESTION DE FLOTTE" :show-back="true">
    <div class="pwa-form-page">

      <!-- Section : Identification -->
      <div class="pwa-section-title">Identification</div>
      <div class="pwa-form-card">
        <div class="pwa-field">
          <label class="pwa-field-label">IMMATRICULATION <span class="pwa-required">*</span></label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-numeric pwa-input-icon"></span>
            <input v-model="form.registration_number" class="pwa-input" placeholder="Ex: 2291 GS 01" />
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">N° CHASSIS (VIN)</label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-barcode pwa-input-icon"></span>
            <input v-model="form.vin" class="pwa-input" placeholder="Ex: 1HGBH41JXMN109186" />
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">COULEUR</label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-palette-outline pwa-input-icon"></span>
            <input v-model="form.color" class="pwa-input" placeholder="Ex: Blanc" />
          </div>
        </div>
      </div>

      <!-- Section : Véhicule -->
      <div class="pwa-section-title">Caractéristiques</div>
      <div class="pwa-form-card">
        <div class="pwa-field">
          <label class="pwa-field-label">MARQUE <span class="pwa-required">*</span></label>
          <div class="pwa-select-wrap">
            <span class="mdi mdi-car-outline pwa-input-icon"></span>
            <select v-model="selectedBrand" class="pwa-select" @change="onBrandChange">
              <option value="" disabled>Sélectionner la marque</option>
              <option v-for="b in brands" :key="b" :value="b">{{ b }}</option>
            </select>
            <span class="mdi mdi-chevron-down pwa-select-arrow"></span>
          </div>
        </div>
        <div v-if="selectedBrand === 'Autre'" class="pwa-field">
          <label class="pwa-field-label">AUTRE MARQUE</label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-car-outline pwa-input-icon"></span>
            <input v-model="form.other_make" class="pwa-input" placeholder="Saisir la marque" />
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">MODÈLE <span class="pwa-required">*</span></label>
          <div class="pwa-select-wrap">
            <span class="mdi mdi-car-side pwa-input-icon"></span>
            <select v-model="selectedModel" class="pwa-select" :disabled="!selectedBrand">
              <option value="" disabled>Sélectionner le modèle</option>
              <option v-for="m in models" :key="m" :value="m">{{ m }}</option>
            </select>
            <span class="mdi mdi-chevron-down pwa-select-arrow"></span>
          </div>
        </div>
        <div v-if="selectedModel === 'Autre' || selectedBrand === 'Autre'" class="pwa-field">
          <label class="pwa-field-label">AUTRE MODÈLE</label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-car-side pwa-input-icon"></span>
            <input v-model="form.other_model" class="pwa-input" placeholder="Saisir le modèle" />
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">ANNÉE</label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-calendar pwa-input-icon"></span>
            <input v-model="form.year" class="pwa-input" type="number" placeholder="Ex: 2021" />
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">TYPE DE VÉHICULE <span class="pwa-required">*</span></label>
          <div class="pwa-select-wrap">
            <span class="mdi mdi-truck-outline pwa-input-icon"></span>
            <select v-model="form.vehicle_type" class="pwa-select">
              <option value="" disabled>Sélectionner le type</option>
              <option v-for="t in vehicleTypes" :key="t.value" :value="t.value">{{ t.text }}</option>
            </select>
            <span class="mdi mdi-chevron-down pwa-select-arrow"></span>
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">TYPE DE CARBURANT <span class="pwa-required">*</span></label>
          <div class="pwa-select-wrap">
            <span class="mdi mdi-gas-station pwa-input-icon"></span>
            <select v-model="form.product" class="pwa-select">
              <option value="" disabled>Sélectionner le carburant</option>
              <option v-for="p in products" :key="p.id" :value="p.id">{{ p.name }}</option>
            </select>
            <span class="mdi mdi-chevron-down pwa-select-arrow"></span>
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">CAPACITÉ RÉSERVOIR (L)</label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-water-outline pwa-input-icon"></span>
            <input v-model="form.reservoir_capacity" class="pwa-input" type="number" placeholder="Ex: 60" />
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">DÉPARTEMENT</label>
          <div class="pwa-select-wrap">
            <span class="mdi mdi-domain pwa-input-icon"></span>
            <select v-model="form.department" class="pwa-select">
              <option value="" disabled>Sélectionner le département</option>
              <option v-for="d in departments" :key="d.id" :value="d.id">{{ d.name }}</option>
            </select>
            <span class="mdi mdi-chevron-down pwa-select-arrow"></span>
          </div>
        </div>
      </div>

      <!-- Section : Suivi kilométrage -->
      <div class="pwa-section-title">Suivi kilométrage</div>
      <div class="pwa-form-card">
        <div class="pwa-toggle-row">
          <div>
            <div class="pwa-toggle-label">Renseigner le kilométrage</div>
            <div class="pwa-toggle-sub">Permet le suivi du kilométrage du véhicule</div>
          </div>
          <label class="pwa-switch">
            <input type="checkbox" v-model="form.is_kmh" />
            <span class="pwa-slider"></span>
          </label>
        </div>
      </div>

      <!-- Section : Conducteur -->
      <div class="pwa-section-title">Conducteur</div>
      <div class="pwa-form-card">
        <div class="pwa-field">
          <label class="pwa-field-label">NOM</label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-account-outline pwa-input-icon"></span>
            <input v-model="form.driver_last_name" class="pwa-input" placeholder="Nom du conducteur" />
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">PRÉNOM</label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-account-outline pwa-input-icon"></span>
            <input v-model="form.driver_first_name" class="pwa-input" placeholder="Prénom du conducteur" />
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">TÉLÉPHONE</label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-phone-outline pwa-input-icon"></span>
            <input v-model="form.driver_phone_number" class="pwa-input" placeholder="+225XXXXXXXXXX" @input="enforcePhone" />
          </div>
        </div>
        <div class="pwa-field">
          <label class="pwa-field-label">CODE SECRET <span class="pwa-required">*</span></label>
          <div class="pwa-input-wrap">
            <span class="mdi mdi-lock-outline pwa-input-icon"></span>
            <input v-model="form.secret_code" class="pwa-input" type="password" inputmode="numeric" maxlength="4" placeholder="4 chiffres" />
          </div>
        </div>
      </div>

      <div v-if="error" class="pwa-error">{{ error }}</div>
    </div>

    <!-- Submit pinned above nav -->
    <div class="pwa-submit-area">
      <button class="pwa-submit-btn" :disabled="saving" @click="save">
        <span v-if="saving" class="mdi mdi-loading mdi-spin" style="margin-right:8px"></span>
        <span v-else class="mdi mdi-check-circle-outline" style="margin-right:8px"></span>
        Ajouter le véhicule
      </button>
    </div>
  </pwa-layout>
</template>

<script>
import PwaLayout from './PwaLayout.vue'
import CompanyVehiclesService from '@/services/CompanyVehiclesService'
import ProductDetailService from '@/services/ProductDetailService'
import DepartmentService from '@/services/DepartmentService'
import { vehicleData, VEHICLE_ITEMS } from '@/utils/consts'

export default {
  name: 'PwaNewVehicle',
  components: { PwaLayout },
  data() {
    return {
      form: {
        registration_number: '',
        vin: '',
        color: '',
        year: '',
        vehicle_type: '',
        product: '',
        reservoir_capacity: '',
        department: '',
        is_kmh: false,
        other_make: '',
        other_model: '',
        driver_last_name: '',
        driver_first_name: '',
        driver_phone_number: '',
        secret_code: '',
      },
      selectedBrand: '',
      selectedModel: '',
      products: [],
      departments: [],
      vehicleTypes: VEHICLE_ITEMS,
      vehicleData,
      saving: false,
      error: null,
    }
  },
  computed: {
    brands() {
      return [...Object.keys(this.vehicleData), 'Autre']
    },
    models() {
      if (!this.selectedBrand || this.selectedBrand === 'Autre') return []
      return [...(this.vehicleData[this.selectedBrand] || []), 'Autre']
    },
  },
  mounted() {
    this.loadProducts()
    this.loadDepartments()
  },
  methods: {
    async loadProducts() {
      try {
        const data = await ProductDetailService.getprincipalAll()
        this.products = data?.results || (Array.isArray(data) ? data : [])
      } catch (e) { console.error(e) }
    },
    async loadDepartments() {
      try {
        const companyId = this.$store.state.app.company?.pk
        if (!companyId) return
        const data = await DepartmentService.getDepartment(companyId)
        this.departments = Array.isArray(data) ? data : (data?.results || [])
      } catch (e) { console.error(e) }
    },
    onBrandChange() {
      this.selectedModel = ''
      this.form.other_make = ''
      this.form.other_model = ''
    },
    enforcePhone() {
      if (!this.form.driver_phone_number) return
      if (!this.form.driver_phone_number.startsWith('+225')) {
        this.form.driver_phone_number = '+225' + this.form.driver_phone_number.replace(/^(\+225)?/, '')
      }
    },
    async save() {
      if (!this.form.registration_number) { this.error = "L'immatriculation est requise."; return }
      if (!this.form.secret_code) { this.error = "Le code secret est requis."; return }
      this.saving = true
      this.error = null
      try {
        const payload = {
          ...this.form,
          make: this.selectedBrand === 'Autre' ? (this.form.other_make || '') : this.selectedBrand,
          model: (this.selectedModel === 'Autre' || this.selectedBrand === 'Autre') ? (this.form.other_model || '') : this.selectedModel,
        }
        await CompanyVehiclesService.create(this, payload)
        this.$router.push('/pwa/vehicles')
      } catch (e) {
        const data = e?.response?.data
        if (data && typeof data === 'object') {
          this.error = Object.entries(data).map(([k, v]) => `${k}: ${v}`).join('\n')
        } else {
          this.error = 'Une erreur est survenue.'
        }
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.pwa-form-page { padding: 16px 16px 120px; }

.pwa-section-title {
  font-size: 12px; font-weight: 700; color: var(--pwa-muted);
  letter-spacing: 0.8px; text-transform: uppercase;
  padding: 16px 4px 8px;
}

.pwa-form-card {
  background: var(--pwa-white); border-radius: var(--pwa-card-radius);
  padding: 16px; display: flex; flex-direction: column; gap: 16px;
}

.pwa-field { display: flex; flex-direction: column; gap: 6px; }
.pwa-field-label {
  font-size: 11px; font-weight: 600; color: var(--pwa-muted);
  letter-spacing: 0.8px; text-transform: uppercase;
}
.pwa-required { color: var(--pwa-error); }

.pwa-input-wrap, .pwa-select-wrap {
  display: flex; align-items: center; gap: 10px;
  background: var(--pwa-bg); border-radius: 12px; padding: 0 14px;
  height: 50px; border: 1.5px solid transparent; transition: border-color 0.2s;
}
.pwa-input-wrap:focus-within, .pwa-select-wrap:focus-within { border-color: var(--pwa-accent); }
.pwa-input-icon { font-size: 18px; color: var(--pwa-muted); flex-shrink: 0; }
.pwa-input {
  flex: 1; border: none; outline: none;
  font-size: 15px; color: var(--pwa-text); background: transparent;
}
.pwa-input::placeholder { color: var(--pwa-muted); }
.pwa-select {
  flex: 1; border: none; outline: none;
  font-size: 15px; color: var(--pwa-text); background: transparent;
  -webkit-appearance: none; appearance: none; cursor: pointer;
}
.pwa-select:disabled { opacity: 0.5; }
.pwa-select-arrow { font-size: 18px; color: var(--pwa-muted); flex-shrink: 0; pointer-events: none; }

/* Toggle */
.pwa-toggle-row { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.pwa-toggle-label { font-size: 14px; font-weight: 600; color: var(--pwa-text); }
.pwa-toggle-sub { font-size: 12px; color: var(--pwa-muted); margin-top: 2px; }
.pwa-switch { position: relative; display: inline-block; width: 46px; height: 26px; flex-shrink: 0; }
.pwa-switch input { opacity: 0; width: 0; height: 0; }
.pwa-slider {
  position: absolute; cursor: pointer; inset: 0;
  background: #D1D9E6; border-radius: 26px; transition: background 0.2s;
}
.pwa-slider:before {
  content: ''; position: absolute;
  width: 20px; height: 20px; left: 3px; bottom: 3px;
  background: white; border-radius: 50%; transition: transform 0.2s;
}
.pwa-switch input:checked + .pwa-slider { background: var(--pwa-accent); }
.pwa-switch input:checked + .pwa-slider:before { transform: translateX(20px); }

.pwa-error {
  color: var(--pwa-error); font-size: 13px; margin-top: 12px;
  padding: 10px 14px; background: #FFEBEE; border-radius: 10px;
  white-space: pre-line;
}

.pwa-submit-area {
  position: fixed; bottom: var(--pwa-nav-h); left: 50%; transform: translateX(-50%);
  width: 100%; max-width: 480px; padding: 12px 16px;
  background: var(--pwa-bg); border-top: 1px solid rgba(0,0,0,0.06);
  z-index: 10;
}
.pwa-submit-btn {
  width: 100%; height: 52px; border-radius: 16px;
  background: var(--pwa-dark); color: white;
  font-size: 16px; font-weight: 600; border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: opacity 0.2s;
}
.pwa-submit-btn:disabled { opacity: 0.6; cursor: not-allowed; }
</style>
